import _kebabCase from 'lodash/kebabCase';

import { Pixall } from 'reaxl-analytics-handlers';

import validateUserInput from '@/utilities/validateUserInput';

import { isVDP } from './utilities';

export function shoppingAssistantIconClick(metadata = {}, option) {
    const {
        dataLayer = {},
    } = metadata;

    const cdl = isVDP(dataLayer) && ({
        eventProperties: {
            tagIndex: 'vdp-160',
        },
    });

    Pixall.sendClickEvent({
        pageType: 'vlp',
        eventSource: 'personalization',
        label: 'icon::shopping-assistant',
        cdl,
    }, dataLayer, option);

    return {};
}

export function shoppingAssistantCTAClick(metadata = {}, option) {
    const {
        data = {},
        dataLayer = {},
    } = metadata;

    const { input = '', isKbb = false, tagIndex } = data;

    const label = isKbb ? 'icon::shopping-assistant' : `shopping-assistant::${_kebabCase(input)}`;

    const element = {
        'vdp-163': 'Schedule Test Drive Button',
        'vdp-164': 'Estimate Payment Button',
        'vdp-165': 'Check Availability Button',
        'vdp-166': 'Features and Specs Button',
    }[tagIndex] || undefined;

    const cdl = isVDP(dataLayer) && ({
        eventProperties: {
            action: 'Click',
            element,
            location: 'Shopping Assistant',
            tagIndex,
        },
    });

    Pixall.sendClickEvent({
        pageType: 'vlp',
        eventSource: 'personalization',
        label,
        cdl,
    }, dataLayer, option);

    return {};
}

// Shopping Assistant - Natural Language Keyword Search Event
export function shoppingAssistantChatSubmit(metadata = {}, option = {}) {
    const {
        data = {},
        state = {},
        dataLayer = {},
    } = metadata;

    const { input = '' } = data;

    const isKBB = state?.brand === 'kbb';

    const { isValid, cleanMessage } = validateUserInput(input);

    const label = `shop-assistant::nls::${_kebabCase(isValid ? cleanMessage : '')}`;

    const cdl = {
        eventProperties: {
            action: 'Text Input',
            element: 'Shop Assistant Keyword Search',
            tagIndex: `${isVDP(dataLayer) ? 'vdp' : 'srp'}-0170`,
        },
        search: {
            keywords: _kebabCase(isValid ? cleanMessage : ''),
        },
    };

    Pixall.sendClickEvent({
        pageType: 'vlp',
        eventSource: isKBB ? 'button' : 'link',
        label,
        cdl,
    }, dataLayer, option);

    return {};
}

export default {
    shoppingAssistantIconClick,
    shoppingAssistantCTAClick,
    shoppingAssistantChatSubmit,
};
